/**
 * Today's `YYYY-MM-DD` calendar date in a Facility's IANA timezone. Falls
 * back to UTC when the zone is missing or not recognized, so a bad Facility
 * record never throws while a form is rendering. Matches the server's rule
 * for rejecting future work dates.
 */
export function todayInTimeZone(
  timeZone?: string | null,
  now: Date = new Date(),
): string {
  const format = (zone: string) =>
    new Intl.DateTimeFormat("en-CA", {
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(now);
  try {
    return format(timeZone || "UTC");
  } catch {
    return format("UTC");
  }
}
